export const LIVE_CHAT_END_CHAT_INTENT = '/DIRECT-end-live-chat';
export const LIVE_CHAT_HEARTBEAT_INTENT = '/DIRECT-live-chat-heartbeat';
export const LIVE_CHAT_UNSUPPORTED_INTENT =
    '/DIRECT-live-chat-client-unsupported';

export const NLU_FALLBACK_INTENT = 'nlu_fallback';
export const SPEAK_WITH_LIVE_PERSON_INTENT = 'mychart.get-me-live-person';
